export default __webpack_public_path__ + "static/media/UncheckedBoxIcon.40a40ff0.svg";